import numeral from "numeral";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useInsuranceStore } from "../../../_store/insuranceStore";
import { FooterAfterSum } from "../../../components/FooterAfterSum/FooterAfterSum";
import { MTButton } from "../../../components/button/MTButton";
import { CardMain, CardProduct } from "../../../components/card/CardMain";
import { STYLE_PADDING_MAIN } from "../../../utils/useStyle";
import CustomHorizontalBarChart from "../../pdf/component/pdf.c.familyChart";
import { first_reload } from "../functions/firstLoad";
import { StatusCard } from "../styles/Card";
import { numberWithoutComma } from "../../balance/component/VIDrawerDebt.Main";

const ViewDisable_Final = ({ setFinal, setTab }) => {
  const navigate = useNavigate();
  const insuranceData = useInsuranceStore((state) => state.insuranceData);
  const balanceData = useBalanceStore((state) => state.balanceData);

  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  const getStatus = () => {
    let disable_more =
      insuranceData.sum_disabled_have_to_money -
      (insuranceData.sum_disabled_insurance_current +
        insuranceData?.sum_disabled_social_security_fund) -
      insuranceData.sum_disabled_asset_current;
    // if (insuranceData.sum_disabled_insurance_more === 0) {
    //   return "normal";
    // } else if (insuranceData.sum_disabled_insurance_more < 0) {
    //   return "toomuch";
    // }

    if (disable_more === 0) {
      return "normal";
    } else if (disable_more < 0) {
      return "toomuch";
    }

    return "more";
  };

  return (
    <div id="first_reload">
      <div className={`${STYLE_PADDING_MAIN} my-3 space-y-5 `}>
        <CardMain
          title={
            <div className=" text-mainblue font-semibold ">
              ผลลัพธ์วางแผนทุนประกันทุพพลภาพ
            </div>
          }
          panel={
            <div className=" px-3  space-y-5 font-medium">
              <div>
                <div>ทุนประกันแนะนำ</div>
                <div className=" text-maincyan font-semibold text-2xl">
                  {/* insuranceData.sum_disabled_have_to_money */}
                  {numeral(insuranceData.sum_disabled_have_to_money)?.format(
                    "0,0"
                  )}{" "}
                  {/* {numeral(insuranceData?.sum_disabled_insurance_net)?.format(
                    "0,0"
                  )}{" "} */}
                  บาท
                </div>
              </div>
              <div>
                <div>ทุนประกันที่คุณมี ณ ปัจจุบัน</div>
                <div className=" text-maincyan font-semibold text-2xl">
                  {numeral(
                    insuranceData?.sum_disabled_insurance_current +
                      insuranceData?.sum_disabled_social_security_fund
                  )?.format("0,0")}{" "}
                  บาท
                </div>
              </div>
              <div>
                <div>รวมมูลค่าสินทรัพย์</div>
                <div className=" text-maincyan font-semibold text-2xl">
                  {numeral(insuranceData?.sum_disabled_asset_current)?.format(
                    "0,0"
                  )}{" "}
                  บาท
                </div>
                <div className=" text-gray-800 text-xs">
                  (สินทรัพย์สภาพคล่อง + สินทรัพย์ลงทุน + สินทรัพย์ไม่มีตัวตน
                  ไม่รวมสินทรัพย์ส่วนตัว)
                </div>
              </div>

              <div className="flex flex-col border border-gray-400 rounded p-3">
                <StatusCard
                  status={getStatus()}
                  value={
                    insuranceData?.sum_disabled_have_to_money -
                    (insuranceData?.sum_disabled_insurance_current +
                      insuranceData?.sum_disabled_social_security_fund) -
                    insuranceData?.sum_disabled_asset_current
                  }
                />
                <div className="text-center">
                  ทุนประกันแนะนำ - ทุนประกันที่คุณมี ณ ปัจจุบัน -
                  (สินทรัพย์สภาพคล่อง + สินทรัพย์ลงทุน + สินทรัพย์ไม่มีตัวตน
                  ไม่รวมสินทรัพย์ส่วนตัว) = ทุนประกันที่ควรซื้อเพิ่ม
                </div>
                <div className="my-2 text-center">
                  {numeral(insuranceData.sum_disabled_have_to_money).format(
                    "0,0"
                  )}{" "}
                  -{" "}
                  {numeral(
                    insuranceData?.sum_disabled_insurance_current +
                      insuranceData?.sum_disabled_social_security_fund
                  )?.format("0,0")}{" "}
                  -{" "}
                  {numeral(insuranceData?.sum_disabled_asset_current)?.format(
                    "0,0"
                  )}
                  {/* ({numeral(balanceData?.sum_property_asset).format("0,0")} +{" "}
                  {numeral(balanceData?.sum_property_intangible).format("0,0")}{" "}
                  + {numeral(balanceData?.sum_property_invest).format("0,0")}) */}
                  ={" "}
                  {numeral(
                    insuranceData.sum_disabled_have_to_money -
                      (insuranceData.sum_disabled_insurance_current +
                        insuranceData?.sum_disabled_social_security_fund) -
                      insuranceData.sum_disabled_asset_current
                  ).format("0,0")}
                </div>
                <div className="w-[300px] flex justify-center mx-auto">
                  <CustomHorizontalBarChart
                    width={120}
                    yourData={[
                      numberWithoutComma(
                        insuranceData.sum_disabled_insurance_current || 0
                      ) +
                        numberWithoutComma(
                          insuranceData?.sum_disabled_social_security_fund || 0
                        ) +
                        numberWithoutComma(
                          insuranceData.sum_disabled_asset_current || 0
                        ),
                      0,
                    ]}
                    recomenedData={[
                      0,
                      insuranceData.sum_disabled_have_to_money,
                    ]}
                    barThickness={40}
                  />
                </div>
              </div>
            </div>
          }
        />
        <MTButton
          onClick={() => {
            setFinal(false);
            setTab(2);
          }}
          text="ย้อนกลับ"
          color="bg-white"
          border="border border-maincyan"
          colortext="text-maincyan group-hover:text-white"
          hovercolor="hover:bg-maincyan group "
          width="w-full"
        />
        <CardProduct
          title={"วางแผนคุ้มครองรายรับจากเหตุไม่คาดฝัน"}
          panel={
            "เบี้ยหลักร้อยต่อเดือนคุ้มครองหลักล้าน หากเกิดเหตุทุพพลภาพถาวร เนื่องจากเจ็บป่วยหรืออุบัติเหตุ ไม่สามารถทำงานมีรายรับ ได้ มีเงินชดเชยมาใช้ในการดำรงชีพและดูแลครอบครัว"
          }
        />
        <FooterAfterSum />
      </div>
    </div>
  );
};

export default ViewDisable_Final;
